// extracted by mini-css-extract-plugin
export default {"container":"style_container__yXT9l","button":"style_button__DyJNh","desc":"style_desc__l0jDX","title":"style_title__N8oC5","label":"style_label__T9JiD"};